import { render, staticRenderFns } from "./remark-handle.vue?vue&type=template&id=084a8da9&"
import script from "./remark-handle.vue?vue&type=script&lang=js&"
export * from "./remark-handle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports